module.exports = __webpack_public_path__ + "static/img/a013.3d7df25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a013.jpg
// module id = JlwB
// module chunks = 0